<template>
  <procedure-page
    :id="$route.params.id"
    :procedure="procedure"
    :load-func="load"
    :status="procedure.status"
    :types="types"
    :isClosed="procedure.isClosed"
    @update:procedureGoodName="procedure.goodName = $event"
    @update:procedureType="procedure.type = $event"
  >
    <AllSubmittedApplications
      :applications="applications"
      :step-code="procedure.status.code"
      :procedureId="procedure.id"
      :subtitle="captionInfo"
      :show-status="showStatus"
      :show-nds-switch="showNdsSwitch"
      :table-replace-caption="tableReplaceCaption"
      :procedure-type="procedure.type"
      :show-start-max-price="showStartMaxPrice"
    />
  </procedure-page>
</template>

<script>
import api from "@/api";
import {mapStores} from "pinia";
import AllSubmittedApplications from "@/components/procedure/AllSubmittedApplications.vue";
import ProcedurePage from "@/components/ProcedurePage.vue";
import {useLibraryStore} from "@/stores/library";

export default {
  name: "AllProcedureApplications",
  components: { AllSubmittedApplications, ProcedurePage },
  data() {
    return {
      procedure: {
        id: null,
        registryNumber: '',
        type: '',
        goodName: '',
        subject: '',
        goodQuantityUnits: '',
        startMaxPrice: '',
        applicationDeadline: null,
        reviewDeadline: null,
        summingStart: null,
        shippingCondition: '',
        statusText: '',
        publishedAt: null,
        organizerName: '',
        status: { name: '', code: '' },
        orgFullName: '',
        isWithoutStartMaxPrice: false,
        partOfVolume: false,
        isClosed: false,
        additionalInformation: null,
        contactPerson: {
          userFullName: null,
          userPhone: null,
          userEmail: null
        }
      },
      types: [],
      applications: [],
      captionInfo: null,
      showStatus: false,
      showNdsSwitch: true,
      tableReplaceCaption: '',
      showStartMaxPrice: false,
    }
  },
  methods: {
    async load(procedureId) {
      const resp = await api.get(`/procedures/${procedureId}/viewAllApps`);
      Object.assign(this.procedure, resp.procedure);
      Object.assign(this.applications, resp.applications);
      this.types = resp.types.map((elem) => ({
        id: elem.id,
        title: elem.name,
        value: elem.code,
      }));
      this.captionInfo = this.libraryStore.callFunctionByCode('getAllProcedureApplicationsCaption', {
        procedure: this.procedure
      }).applicationsCaptionInfo ?? null;
      this.showStatus = this.libraryStore.callFunctionByCode('getShowSubmittedApplicationsStatus', {
        procedure: this.procedure
      }).showSubmittedApplicationsStatus ?? false;
      this.showNdsSwitch = this.libraryStore.callFunctionByCode('getShowSubmittedApplicationsNdsSwitch', {
        procedure: this.procedure
      }).showSubmittedApplicationsNdsSwitch ?? true;
      const data = this.libraryStore.callFunctionByCode('getPositionsViewOptions', {
        procedureType: this.procedure.type,
        procedureStep: this.procedure.status.code,
      });
      this.tableReplaceCaption = data.tableReplaceCaption ?? '';
      this.showStartMaxPrice = data.showStartMaxPrice ?? false;
    }
  },
  computed: {
    ...mapStores(useLibraryStore),
  }
}
</script>
